// Import Shepherd library and its type
import Shepherd from 'shepherd.js';

/**
 * Gets the current Shepherd.js tour.
 *
 * @returns {Shepherd.Tour} The tour instance.
 */
const getCurrentWalkthrough = () => {
	// Get the current tour
	const tour = Shepherd.activeTour; // returns Shepherd.Tour or undefined if no tour is active

	if ( ! tour ) {
		return;
	}

	// Return the current tour
	return tour;
}

export default getCurrentWalkthrough;
